import React from "react";
import { Card, CardBody, Col } from "reactstrap";
import ReactApexChart from "react-apexcharts";

const GrowthChart = ({ leadsStats }) => {
  const growth = leadsStats?.growth || {};
  const dailyGrowth = growth.dailyGrowth || [];
  const thisMonth = growth.thisMonth || 0;
  const lastMonth = growth.lastMonth || 0;
  const growthRate = growth.growthRate || 0;

  // Prepare chart data
  const chartData = {
    series: [
      {
        name: "Nuevos Leads",
        data: dailyGrowth.map(item => item.count),
      },
    ],
    options: {
      chart: {
        type: "line",
        height: 300,
        toolbar: {
          show: false,
        },
      },
      stroke: {
        curve: "smooth",
        width: 3,
      },
      colors: ["#556ee6"],
      xaxis: {
        categories: dailyGrowth.map(item => {
          const date = new Date(item.date);
          return date.toLocaleDateString("es-ES", { day: "numeric", month: "short" });
        }),
        labels: {
          style: {
            fontSize: "12px",
          },
        },
      },
      yaxis: {
        title: {
          text: "Leads",
        },
      },
      grid: {
        borderColor: "#f1f1f1",
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return val + " leads";
          },
        },
      },
    },
  };

  const isGrowthPositive = growthRate >= 0;
  const growthIcon = isGrowthPositive 
    ? "ri-arrow-right-up-line" 
    : "ri-arrow-right-down-line";
  const growthClass = isGrowthPositive ? "text-success" : "text-danger";

  return (
    <React.Fragment>
      <Col lg={8}>
        <Card>
          <CardBody>
            <div className="d-flex align-items-center justify-content-between mb-3">
              <div>
                <h4 className="card-title mb-1">Crecimiento de Leads</h4>
                <p className="text-muted mb-0" style={{ fontSize: "13px" }}>
                  Últimos 30 días
                </p>
              </div>
              <div className="text-end">
                <span className={`badge ${isGrowthPositive ? 'bg-success-subtle text-success' : 'bg-danger-subtle text-danger'} font-size-12`}>
                  {growthRate >= 0 ? "+" : ""}
                  {growthRate.toFixed(1)}%
                  <i className={`${growthIcon} align-bottom ms-1`}></i>
                </span>
              </div>
            </div>

            <div id="growth-chart" style={{ position: "relative", height: "280px" }}>
              {dailyGrowth.length > 0 ? (
                <ReactApexChart
                  options={chartData.options}
                  series={chartData.series}
                  type="line"
                  height={280}
                />
              ) : (
                <div className="text-center text-muted py-5">
                  No hay datos de crecimiento disponibles
                </div>
              )}
            </div>
          </CardBody>
        </Card>
      </Col>
    </React.Fragment>
  );
};

export default GrowthChart;

